// extracted by mini-css-extract-plugin
module.exports = {"shape":"loading_shape__aNCbz","transform-animation":"loading_transform-animation__93Er3"};